<template>
  <div id="app">
    <router-view :key="$route.fullPath" v-if="isRouterAlive" />
  </div>
</template>
 
<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
 
<style>
#app {
  padding: 0px;
  margin: 0px;
  /* font-family: Noto Serif SC; 思源宋体*/
  font-family: Microsoft YaHei;
  font-style: normal;
  font-weight: 400;
}
</style>